import DynamicSelect from "@/shared/components/DynamicSelect/DynamicSelect.vue";
import { DynamicSelectConfig } from "@/shared/components/DynamicSelect/model/DynamicSelectConfig";
import { DynamicSelectData } from "@/shared/components/DynamicSelect/model/DynamicSelectData";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import { FORM_VALIDATORS } from "@/shared/constants/FormConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import lodash from "lodash";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {
  COLLECTIONS_BIGQUERY,
  DASHBOARD_FIELDS,
  DASHBOARD_OPERATIONS,
  DASHBOARD_OPERATIONS_LIST,
  DASHBOARD_OPERATIONS_TAGAS,
  DASHBOARD_TEMPLATE_EVENTS,
  DASHBOARD_TEMPLATE_MESSAGES,
  DATA_TYPE,
  DEFAULT_COLOR,
  INDICATOR,
  SPECIAL_FIELDS_LIST,
  TAG
} from "../../constants/DashboardTemplatesConstants";
import { IndicatorOrTag } from "../../models/IndicatorOrTag";
import { SectionOfDashboard } from "../../models/SectionOfDashboard";

@Component({
  name: "Indicator",
  components: {
    DynamicSelect
  }
})
export default class Indicator extends Vue {
  @Prop({ required: true }) sectionOfDashboard!: SectionOfDashboard;
  @Prop() optionsToIndicator!: DynamicSelectData[];
  @Prop() tagOrIndicator!: string;
  @Prop() tags!: IndicatorOrTag[];
  @Prop() indicators!: IndicatorOrTag[];
  @Prop() elementToEdit?: IndicatorOrTag;

  isFormValid = false;

  operation = [] as DynamicSelectData[];
  operationsConfig: DynamicSelectConfig = {
    multiple: false,
    default: [],
    chips: true,
    notFound: false,
    listAll: lodash.cloneDeep(DASHBOARD_OPERATIONS_TAGAS),
    filled: false,
    messageLabel: DASHBOARD_TEMPLATE_MESSAGES.CHOOSE_OPERATION,
    hideDetails: false,
    required: true,
    attach: false
  };

  tag1 = [] as DynamicSelectData[];
  tag2 = [] as DynamicSelectData[];
  tagsFieldsConfig: DynamicSelectConfig = {
    multiple: false,
    default: [],
    chips: true,
    notFound: false,
    listAll: [],
    filled: false,
    messageLabel: DASHBOARD_TEMPLATE_MESSAGES.CHOOSE_TAG,
    hideDetails: false,
    required: true,
    attach: false
  };

  fieldToOperate = [] as DynamicSelectData[];
  fieldToOperateConfig: DynamicSelectConfig = {
    multiple: false,
    default: [],
    chips: true,
    notFound: false,
    listAll: [],
    filled: false,
    messageLabel: DASHBOARD_TEMPLATE_MESSAGES.CHOOSE_TAG,
    hideDetails: false,
    required: true,
    attach: false
  };

  allFormsSelectorOption = [{ id: "allForms", name: "allForms" }];
  selectorFieldToOperate = [] as DynamicSelectData[];
  selectorFieldToOperateConfig: DynamicSelectConfig = {
    multiple: false,
    default: [],
    chips: true,
    notFound: false,
    listAll: [],
    filled: false,
    messageLabel: DASHBOARD_TEMPLATE_MESSAGES.CHOOSE_SELECTOR_FIELD_TO_OPERATE,
    hideDetails: false,
    required: false,
    attach: false
  };

  primaryBtnClass = STYLE_CLASSES.PRIMARY_BTN;
  showFieldToOperate = false;
  showSelectorFieldToOperate = false;
  requiredField = [
    FORM_VALIDATORS.REQUIRED_FIELD,
    FORM_VALIDATORS.NOT_BLANK_SPACES_VALIDATOR
  ];
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  indicatorOrTagName = "";
  color = "#63c7e7";
  edgeTag = false;
  edgeColor = "#63c7e7";
  textColor = "#63c7e7";

  mounted() {
    if (this.tagOrIndicator == INDICATOR) {
      this.initIndicatorForm();
      return;
    }
    this.initTagForm();
  }

  cancelIndicator() {
    this.resetFormState();
    this.$emit(DASHBOARD_TEMPLATE_EVENTS.CLOSE_INDICATOR_MODAL);
  }

  saveIndicatorOrTag() {
    if (this.tagOrIndicator == INDICATOR) {
      this.saveIndicator();
      return;
    }
    this.saveTag();
  }

  saveIndicator() {
    const indicatorNameRepeated = this.indicators.find(
      indicator => indicator.indicatorOrTagName == this.indicatorOrTagName
    );
    if (
      indicatorNameRepeated &&
      indicatorNameRepeated.indicatorOrTagName !=
        this.elementToEdit?.indicatorOrTagName
    ) {
      Snackbar.popError(DASHBOARD_TEMPLATE_MESSAGES.INDICATOR_NAME_REPEATED);
      //this.cleanComponent();
      return;
    }

    const edgeColor = (this.edgeTag ? this.edgeColor : "") || DEFAULT_COLOR;
    const payload = {
      indicatorOrTagName: this.indicatorOrTagName,
      tagOrIndicator: this.tagOrIndicator,
      formulaToCreateIndicator: [this.tag1, this.operation, this.tag2],
      show: indicatorNameRepeated?.show || false,
      color: this.color,
      edgeColor,
      textColor: this.textColor
    };
    this.resetFormState();
    this.$emit(DASHBOARD_TEMPLATE_EVENTS.CLOSE_INDICATOR_MODAL, payload);
  }

  saveTag() {
    const tagNameRepeated = this.tags.find(
      tag => tag.indicatorOrTagName == this.indicatorOrTagName
    );
    if (
      tagNameRepeated &&
      tagNameRepeated.indicatorOrTagName !=
        this.elementToEdit?.indicatorOrTagName
    ) {
      Snackbar.popError(DASHBOARD_TEMPLATE_MESSAGES.TAG_NAME_REPEATED);
      //this.cleanComponent();
      return;
    }
    const edgeColor = (this.edgeTag ? this.edgeColor : "") || DEFAULT_COLOR;
    const payload = {
      indicatorOrTagName: this.indicatorOrTagName,
      fieldToOperate: this.fieldToOperate,
      selectorFieldToOperate: this.selectorFieldToOperate,
      tagOrIndicator: this.tagOrIndicator,
      operation: this.operation,
      show: tagNameRepeated?.show || false,
      color: this.color,
      edgeColor,
      textColor: this.textColor
    };

    if (this.operation[0].id == DASHBOARD_OPERATIONS.COUNT) {
      payload.fieldToOperate = [
        {
          id: DASHBOARD_FIELDS.DOC_ID,
          name: DASHBOARD_FIELDS.DOC_ID,
          collection: {
            name: this.fieldToOperate[0].name,
            id: this.fieldToOperate[0].id
          }
        }
      ];
    } else {
      if (
        (!Array.isArray(this.selectorFieldToOperate) ||
          this.selectorFieldToOperate.length === 0 ||
          !this.selectorFieldToOperate[0]?.id) &&
        this.fieldToOperate[0]?.collection?.id == COLLECTIONS_BIGQUERY.FORMS
      ) {
        payload.selectorFieldToOperate = this.allFormsSelectorOption;
      }
    }

    this.resetFormState();
    this.$emit(DASHBOARD_TEMPLATE_EVENTS.CLOSE_INDICATOR_MODAL, payload);
  }

  onOperationChange() {
    this.showFieldToOperate = true;
    if (
      this.operation &&
      this.operation[0] &&
      this.operation[0].id == DASHBOARD_OPERATIONS.COUNT
    ) {
      this.fieldToOperateConfig.listAll = this.sectionOfDashboard.collections.map(
        collection => ({
          id: collection.collection[0].id,
          name: collection.collection[0].name
        })
      );

      return;
    }
    this.fieldToOperateConfig.listAll = this.optionsToIndicator
      .filter(option => option.type == DATA_TYPE.NUMBER)
      .map(option => ({
        id: option.id,
        name: `${option.name} (${option.collection?.name})`,
        collection: option.collection,
        formTemplate: option.formTemplate
      }));
  }

  @Watch("fieldToOperate")
  onFieldToOperateChange() {
    if (this.fieldToOperate.length == 0) {
      this.selectorFieldToOperate = [];
    }
    this.selectorFieldToOperateConfig.listAll = this.optionsToIndicator
      .filter(
        option =>
          option.collection?.id == this.fieldToOperate[0].collection?.id &&
          option.id &&
          SPECIAL_FIELDS_LIST.includes(option.id)
      )
      .map(option => ({
        id: option.id,
        name: `${option.name} (${option.collection?.name})`,
        collection: option.collection
      }));
    if (this.selectorFieldToOperateConfig.listAll.length > 0) {
      this.showSelectorFieldToOperate = true;
    } else {
      this.showSelectorFieldToOperate = false;
    }
  }

  initIndicatorForm() {
    this.tagsFieldsConfig.listAll = this.tags.map((tag: IndicatorOrTag) => ({
      id: tag.indicatorOrTagName,
      name: tag.indicatorOrTagName
    }));

    this.operationsConfig.listAll = lodash.cloneDeep(DASHBOARD_OPERATIONS_LIST);
    if (this.elementToEdit) {
      if (this.elementToEdit?.indicatorOrTagName) {
        this.indicatorOrTagName = this.elementToEdit.indicatorOrTagName;
        const formulaToCreateIndicator = this.elementToEdit
          .formulaToCreateIndicator!;
        this.tag1 = Array.isArray(formulaToCreateIndicator[0])
          ? formulaToCreateIndicator[0]
          : [formulaToCreateIndicator[0]];
        this.operation = Array.isArray(formulaToCreateIndicator[0])
          ? formulaToCreateIndicator[1]
          : [formulaToCreateIndicator[1]];
        this.tag2 = Array.isArray(formulaToCreateIndicator[0])
          ? formulaToCreateIndicator[2]
          : [formulaToCreateIndicator[2]];
        this.applyColorsFromEdit();
      }
      this.showFieldToOperate = true;
    }
  }

  initTagForm() {
    if (!this.elementToEdit || !this.elementToEdit?.indicatorOrTagName) {
      return;
    }
    this.operation = this.renderOperation(
      this.elementToEdit.operation
    ) as DynamicSelectData[];
    this.onOperationChange();
    this.indicatorOrTagName = this.elementToEdit.indicatorOrTagName;
    this.fieldToOperate = [];
    const currentFieldOperation = this.elementToEdit.fieldToOperate as
      | DynamicSelectData[]
      | undefined;
    if (currentFieldOperation && currentFieldOperation[0]) {
      if (currentFieldOperation[0].id == DASHBOARD_FIELDS.DOC_ID) {
        const fieldSelect = this.fieldToOperateConfig.listAll.find(
          x => x.id == currentFieldOperation[0].collection!.id
        );
        this.fieldToOperate = fieldSelect ? [fieldSelect] : [];
      } else {
        const fieldSelect = this.fieldToOperateConfig.listAll.find(
          x => x.id == currentFieldOperation[0].id
        );
        this.fieldToOperate = fieldSelect ? [fieldSelect] : [];
      }
      this.selectorFieldToOperate =
        this.elementToEdit.selectorFieldToOperate || [];
    }
    this.applyColorsFromEdit();
  }

  applyColorsFromEdit() {
    this.color = this.elementToEdit?.color || "#63c7e7";
    this.textColor = this.elementToEdit?.textColor || "#63c7e7";
    this.edgeTag = !(this.elementToEdit?.edgeColor == "#00000000");
    this.edgeColor =
      (this.edgeTag ? this.elementToEdit?.edgeColor : "") || "#63c7e7";
  }

  renderOperation(operation?: { id: string; name: string }[] | string) {
    if (!operation) {
      return;
    }
    if (typeof operation == DATA_TYPE.STRING) {
      const operationFound = (this.tagOrIndicator == TAG
        ? DASHBOARD_OPERATIONS_TAGAS
        : DASHBOARD_OPERATIONS_LIST
      ).find(op => op.id == operation);

      return operationFound ? [{ ...operationFound }] : [];
    }
    return operation;
  }

  resetFormState() {
    this.indicatorOrTagName = "";
    this.operation = [];
    this.color = "";
    //tags
    this.fieldToOperate = [];
    //indicato
    this.tag1 = [];
    this.tag2 = [];
  }

  get editOrCreate(): string {
    return this.elementToEdit?.indicatorOrTagName ? "Editar" : "Crear";
  }
}
